import { useCallback, useRef } from "react";
import { logout } from "../../../auth/frontegg";
import fetchReadmeToken from "../../../auth/readme";

const useDocsRedirects = (user, location) => {
  const isReadmeDocs = useRef(false);

  return useCallback(async () => {
    const searchParams = new URLSearchParams(location.search);
    const redirectBack = searchParams.get("redirectUri");

    if (redirectBack === "/readme-token") {
      isReadmeDocs.current = true;
      await fetchReadmeToken(user);
    }

    if (redirectBack === "/logout") {
      isReadmeDocs.current = false;
      logout({ returnTo: window.location.origin });
    }

    return isReadmeDocs.current;
  }, [user, location]);
};

export default useDocsRedirects;
